//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE NAS PÁGINAS DE CHECKOUT, DETALHES,          //
//  HOME E NA ALTERAÇÃO DE QUANTIDADE DE PRODUTOS       //
//  DIRETAMENTE PELO CARRINHO (ABA LATERAL DIREITA)     //   
//                                                      //   
//  FUNCIONALIDADE: SINAL DE QUE AS INFORMAÇÕES         //
//    DAS PÁGINAS ESTÃO SENDO CARREGADAS                //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/produto_carrinho.js                     //
//      frontend/src/pages/chekout.js                                   //
//      frontend/src/pages/detalhe.js                                   //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



function Loader() {
    return (  // RENDERIZA O COMPONENTE
        <div class="whole-page center mw-100 mh-100">
            <div class="loader mw-100 mh-100"></div>
        </div>
    );
  }

  export default Loader;
  